import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ScreenerResultsCtx } from 'domains/signup/screener/Components/ScreenerResultsSummary/context';
import { Card } from 'components/Card';
import { Heading, Paragraph } from 'components/Typography';
import { ScreenerGradeBadge } from 'domains/signup/screener/Components/ProgressBadge';

export const ScreenerResultsIntroSection: React.FC = () => {
  const { results } = useContext(ScreenerResultsCtx);
  const { t } = useTranslation();

  const { recommendEvaluation, areas, targetPatient } = results;

  return (
    <section>
      <Heading level="h2" useDefaultMargins>
        {t(`screener.results.title.evalRecommended.${recommendEvaluation}.${targetPatient}`)}
      </Heading>
      <Paragraph useDefaultMargins>
        {t(`screener.results.subTitle.evalRecommended.${recommendEvaluation}.${targetPatient}`)}
      </Paragraph>
      <Card className="flex flex-col gap-16">
        <div className="flex justify-between text-black-500">
          <Heading level="h8">{t(`screener.results.areas.title.${targetPatient}`)}</Heading>
          <Heading level="h8" className="sm-d:hidden">
            {t('screener.results.areas.yourResults')}
          </Heading>
        </div>

        {areas.map(({ area, result }) => (
          <div key={area} className="flex justify-between pb-16 border-b border-black-200 gap-8 sm-d:flex-col">
            <Heading level="h7" className="font-bold">
              {t(`screener.results.areas.areaName.${area}`)}
            </Heading>
            <ScreenerGradeBadge grade={result} />
          </div>
        ))}
      </Card>
    </section>
  );
};
